export enum RatingQueryType {
    Fleet = 0,
    Vendor = 1
}